import { render, staticRenderFns } from "./ViuHeaderEnrichmentError.vue?vue&type=template&id=908e5bb6&scoped=true"
import script from "./ViuHeaderEnrichmentError.vue?vue&type=script&lang=js"
export * from "./ViuHeaderEnrichmentError.vue?vue&type=script&lang=js"
import style0 from "./ViuHeaderEnrichmentError.vue?vue&type=style&index=0&id=908e5bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908e5bb6",
  null
  
)

export default component.exports